import { createQueryKey, useCreateMutation } from '@melio/api-client';
import { AuthPayorApiClient, AuthPayorResponsePropeties, PostAuthPayorRequest } from '@melio/platform-api-axios-client';
import { MutationObserverResult } from 'react-query';

export type { PostAuthPayorRequest };
export type PayorAuthResponse = AuthPayorResponsePropeties;

type GuestPayorAuthenticationResults = Pick<MutationObserverResult, 'isError' | 'isLoading' | 'error'> & {
  authenticate: (payload: PostAuthPayorRequest) => Promise<PayorAuthResponse>;
};

export const useGuestPayorAuthentication = (): GuestPayorAuthenticationResults => {
  const queryKey = createQueryKey({ queryKey: 'AuthPayorApi', role: 'model', scope: 'default' });
  const authenticateMutation = useCreateMutation(AuthPayorApiClient.payorAuthWithPaymentRequestLink, queryKey);

  return {
    ...authenticateMutation,
    authenticate: authenticateMutation.mutateAsync,
  };
};
